type LogLevel = "info" | "warn" | "error" | "success";

interface LogEntry {
  id: string;
  timestamp: string;
  level: LogLevel;
  message: string;
  data?: any;
}

class LogManager {
  private listeners: ((log: LogEntry) => void)[] = [];
  private logs: LogEntry[] = [];

  log(level: LogLevel, message: string, data?: any) {
    const entry: LogEntry = {
      id: Math.random().toString(36).substr(2, 9),
      timestamp: new Date().toLocaleTimeString(),
      level,
      message,
      data,
    };

    this.logs.push(entry);
    if (this.logs.length > 100) this.logs.shift(); // Keep last 100

    this.listeners.forEach((l) => l(entry));

    // Also log to console
    const consoleArgs = [message];
    if (data) consoleArgs.push(data);

    switch (level) {
      case "error":
        console.error(...consoleArgs);
        break;
      case "warn":
        console.warn(...consoleArgs);
        break;
      default:
        console.log(...consoleArgs);
    }
  }

  subscribe(listener: (log: LogEntry) => void) {
    this.listeners.push(listener);
    return () => {
      this.listeners = this.listeners.filter((l) => l !== listener);
    };
  }

  getHistory() {
    return this.logs;
  }
}

export const logger = new LogManager();

export const debugLog = (msg: string, data?: any) =>
  logger.log("info", msg, data);
export const debugWarn = (msg: string, data?: any) =>
  logger.log("warn", msg, data);
export const debugError = (msg: string, data?: any) =>
  logger.log("error", msg, data);
export const debugSuccess = (msg: string, data?: any) =>
  logger.log("success", msg, data);
